import { css } from 'styled-components';
export const sizeMapping = {
    48: {
        style: css `
      font-size: 16px;
      line-height: 24px;
      padding: 10px 20px;
      border-radius: 99px;
      min-height: 48px;
    `,
        iconSize: 20,
    },
    40: {
        style: css `
      font-size: 14px;
      padding: 8px 16px;
      border-radius: 99px;
      min-height: 40px;
    `,
        iconSize: 16,
    },
    32: {
        style: css `
      font-size: 12px;
      padding: 6px 12px;
      border-radius: 99px;
      min-height: 32px;
    `,
        iconSize: 14,
    },
    24: {
        style: css `
      font-size: 11px;
      padding: 4px 8px;
      border-radius: 99px;
      min-height: 24px;

      &::after {
        margin-top: -4px;
      }
    `,
        iconSize: 12,
    },
};
